import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import{ APP_FILE_MESSAGING_TEMPLATES, APP_FILE_TEMPLATES_LIST } from "./Templates.constants";
const TemplatesList = Loadable(
  lazy(() =>
    import("./TemplatesList").then(({ TemplatesList }) => ({
      default: TemplatesList,
    }))
  )
);

const MessagingTemplate = Loadable(
  lazy(() =>
    import("./Template").then(({ MessagingTemplate }) => ({
      default: MessagingTemplate,
    }))
  )
);

export const TemplatesRoutes = [
 {
        path: `${APP_FILE_TEMPLATES_LIST}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TEMPLATES]}>
            <TemplatesList />
          </AuthorizedRoute>
        ),
      },

      {
        path: `${APP_FILE_MESSAGING_TEMPLATES}`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TEMPLATES]}>
            <MessagingTemplate />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_MESSAGING_TEMPLATES}/:templateCode`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TEMPLATES]}>
            <MessagingTemplate />
          </AuthorizedRoute>
        ),
      },
      {
        path: `${APP_FILE_MESSAGING_TEMPLATES}/duplicate/:templateCode`,
        exact: true,
        element: (
          <AuthorizedRoute moduleKeys={[MODULE_IDS.TEMPLATES]}>
            <MessagingTemplate isDuplicate />
          </AuthorizedRoute>
        ),
      },
];
